var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"catalogo_mt"}},[_c('v-power-catalogo',{attrs:{"parametros":_vm.parametros}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }